const isInputNumeric = (input) => {
    return /^[0-9]+$/.test(input);
};

export default isInputNumeric;
